import Modal from "./Modal";
import Edit from './Edit'
import Confirm from './Confirm'
import { componentOpenDelete, componentOpenEdit } from './utils';
import {useState} from "react";


export default function SubordinateItem(props) {

	const {idSub,  onDelete} = props;
	const [name,setName] = useState(props.name)
	const editUser=(newName)=>{
        setName(newName);
    }
  function deleteUser() {
    onDelete(idSub)
  }

	return (
		<tr>
      <td className="organization-wrapper">
        <p>{name}</p>
          <div className='organization_img'>
            <Modal additional={{name: name, type:'user', id:idSub, editUser:editUser}} componentOpen={componentOpenEdit} component={Edit}/>
            <Modal additional={{funcYes: deleteUser, text: "Вы уверенны что хотите удалить?"}} componentOpen={componentOpenDelete} component={Confirm}/>
                    {/* <AdminSubordinateModalEdit name={name} idSub={idSub}/>
                    <SubordinateDelete name={name} idSub={idSub} onDelete={onDelete}/>                */}
          </div>
      </td>
		</tr> 
	)
}
